import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/emails/')({
  beforeLoad: () => {
    throw redirect({
      to: '/emails/inbox',
    })
  },
})
